var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var JobsState_1;
import { HttpErrorResponse } from '@angular/common/http';
import { FeaturesRoutingEnum } from '@features/features-routing.enum';
import { Navigate } from '@ngxs/router-plugin';
import { Action, createSelector, Selector, State, Store } from '@ngxs/store';
import { patch } from '@ngxs/store/operators';
import { CompaniesState } from '@store/companies/companies.state';
import { FindJobs, GetJob, HandleErrors, InitStaticData, SetJob } from '@store/jobs/jobs.actions';
import { JobWebservice } from '@webservices/job-api/job.webservice';
import { buildUrl } from '@wizbii/angular-utilities';
import { of, throwError, zip } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
const defaultState = {
    jobs: {},
    jobList: {},
    domains: [],
    experiences: [],
    contracts: [],
    durations: [],
    studyLevels: [],
    status: [],
    error: null,
};
export const NB_ITEMS_TO_DISPLAY = 20;
let JobsState = JobsState_1 = class JobsState {
    constructor(jobWebservice, store) {
        this.jobWebservice = jobWebservice;
        this.store = store;
    }
    static job(jobId) {
        return createSelector([JobsState_1], (state) => {
            return state.jobs[jobId];
        });
    }
    static list(companyId, page) {
        return createSelector([JobsState_1], (state) => {
            return state.jobList[companyId].slice(0, page * NB_ITEMS_TO_DISPLAY);
        });
    }
    static listLength(companyId) {
        return createSelector([JobsState_1], (state) => {
            return (state.jobList[companyId] || []).length;
        });
    }
    static domains(state) {
        return state.domains;
    }
    static contracts(state) {
        return state.contracts;
    }
    static durations(state) {
        return state.durations;
    }
    static studyLevels(state) {
        return state.studyLevels;
    }
    static status(state) {
        return state.status;
    }
    static experiences(state) {
        return state.experiences;
    }
    static error(state) {
        return state.error;
    }
    initStaticData(ctx) {
        const { domains, contracts, durations, status, studyLevels, experiences } = ctx.getState();
        if (domains.length > 0 &&
            contracts.length > 0 &&
            durations.length > 0 &&
            status.length > 0 &&
            studyLevels.length > 0 &&
            experiences.length > 0) {
            return undefined;
        }
        return zip(this.jobWebservice.getDomains(), this.jobWebservice.getContracts(), this.jobWebservice.getDurations(), this.jobWebservice.getStudyLevels(), this.jobWebservice.getStatus(), this.jobWebservice.getExperiences()).pipe(switchMap(([_domains, _contracts, _durations, _studyLevels, _status, _experiences]) => of(ctx.patchState({
            domains: _domains,
            contracts: _contracts,
            durations: _durations,
            studyLevels: _studyLevels,
            status: _status,
            experiences: _experiences,
        }))), catchError((err) => {
            if (err instanceof HttpErrorResponse && err.status === 500) {
                return throwError(new Error('Internal Server Error while getting datas'));
            }
            return throwError(err);
        }));
    }
    setJob(ctx, { job }) {
        return ctx.setState(patch({
            jobs: patch({ [job._id]: job }),
        }));
    }
    getJob(ctx, { jobId }) {
        const { jobs } = ctx.getState();
        if (!jobs[jobId]) {
            ctx.patchState({ error: null });
            return this.jobWebservice.get(jobId).pipe(switchMap(newJob => {
                if (newJob.companyId !== this.store.selectSnapshot(CompaniesState.authenticatedCompanyId)) {
                    console.error(`Not found - job.companyId !== authenticatedCompany.id [jobId=${jobId}]`);
                    return ctx.dispatch(new Navigate([buildUrl(FeaturesRoutingEnum.NotFound)], undefined, { skipLocationChange: true }));
                }
                return ctx.dispatch(new SetJob(newJob));
            }), catchError(error => {
                switch (error.status) {
                    // The Job doesn't exist so => 404
                    case 404: {
                        console.error(`Not found - [jobId=${jobId}]`);
                        ctx.patchState({ error });
                        return ctx.dispatch(new Navigate([buildUrl(FeaturesRoutingEnum.NotFound)], undefined, { skipLocationChange: true }));
                    }
                    // We are not authorized to access this job => 403
                    case 403: {
                        console.error(`Forbidden - [jobId=${jobId}]`);
                        ctx.patchState({ error });
                        return ctx.dispatch(new Navigate(['/'], undefined));
                    }
                    default: {
                        console.error(`Code ${error.status} => ${error.statusText} - [jobId=${jobId}]`);
                        return of(ctx.patchState({ error }));
                    }
                }
            }));
        }
    }
    getAllJob(ctx, { companyId }) {
        return this.jobWebservice.find(companyId).pipe(map(jobList => ctx.setState(patch({
            jobList: patch({ [companyId]: jobList }),
        }))), 
        // tslint:disable-next-line:no-identical-functions
        catchError(error => ctx.dispatch(new HandleErrors(error))));
    }
    handleErrors(ctx, { error }) {
        // tslint:disable no-small-switch
        switch (error.status) {
            // The Job doesn't exist so => 404
            case 404: {
                console.error('Not found - [jobs]');
                ctx.patchState({ error });
                return ctx.dispatch(new Navigate([buildUrl(FeaturesRoutingEnum.NotFound)], undefined, { skipLocationChange: true }));
            }
            default: {
                console.error(`Code ${error.status} => ${error.statusText}  - [jobs]`);
                return ctx.patchState({ error });
            }
        }
        // tslint:enable no-small-switch
    }
};
__decorate([
    Action(InitStaticData),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], JobsState.prototype, "initStaticData", null);
__decorate([
    Action(SetJob),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, SetJob]),
    __metadata("design:returntype", void 0)
], JobsState.prototype, "setJob", null);
__decorate([
    Action(GetJob),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, GetJob]),
    __metadata("design:returntype", void 0)
], JobsState.prototype, "getJob", null);
__decorate([
    Action(FindJobs),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, FindJobs]),
    __metadata("design:returntype", void 0)
], JobsState.prototype, "getAllJob", null);
__decorate([
    Action(HandleErrors),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, HandleErrors]),
    __metadata("design:returntype", void 0)
], JobsState.prototype, "handleErrors", null);
__decorate([
    Selector(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], JobsState, "domains", null);
__decorate([
    Selector(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], JobsState, "contracts", null);
__decorate([
    Selector(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], JobsState, "durations", null);
__decorate([
    Selector(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], JobsState, "studyLevels", null);
__decorate([
    Selector(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], JobsState, "status", null);
__decorate([
    Selector(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], JobsState, "experiences", null);
__decorate([
    Selector(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], JobsState, "error", null);
JobsState = JobsState_1 = __decorate([
    State({
        name: 'jobs',
        defaults: defaultState,
    }),
    __metadata("design:paramtypes", [JobWebservice, Store])
], JobsState);
export { JobsState };
